import axios from "axios";

import type { PromptType as Prompt } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client/queryOption";

export async function getPromptsFn() {
	const response = await axios.get<Prompt[]>(`${env.apiUrl}/prompts`);

	return response.data;
}

export const getPrompts = queryOptions({
	queryKey: "prompts",
	queryFn: getPromptsFn,
});

export async function deletePromptById(promptId: string) {
	const response = await axios.delete<Prompt>(`${env.apiUrl}/prompts/${promptId}`);

	return response.data;
}

export async function createPrompt(prompt: Partial<Prompt>) {
	const response = await axios.post<Prompt>(`${env.apiUrl}/prompts`, prompt);

	return response.data;
}

export async function updatePromptById({
	promptId,
	prompt,
}: {
	promptId: string;
	prompt: Partial<Prompt>;
}) {
	const response = await axios.put<Prompt>(`${env.apiUrl}/prompts/${promptId}`, prompt);

	return response.data;
}
